import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import Logo from '../common/Logo';

const Navbar = () => {
  const location = useLocation();
  const isAdmin = location.pathname.includes('/admin');

  if (isAdmin) return null;

  return (
    <nav className="sticky top-0 z-50 bg-brand-bg/95 backdrop-blur-md border-b border-brand-border safe-pt transition-colors duration-200">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between md:justify-start h-[70px] md:h-[70px] relative">
          
          {/* Logo & Brand - Centered on Mobile, Left on Desktop */}
          <div className="absolute left-1/2 -translate-x-1/2 md:static md:translate-x-0 flex items-center">
            <Link to="/" className="flex items-center gap-3">
              <Logo className="w-[48px] h-[48px] md:w-[52px] md:h-[52px]" />
              <span className="text-[22px] md:text-xl font-bold tracking-tight text-brand-text mt-0.5">
                Pulse5
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8 ml-10">
            <Link to="/" className={`text-sm font-bold transition-all ${location.pathname === '/' ? 'text-brand-text underline underline-offset-4 decoration-2 decoration-brand-text' : 'text-brand-secondary hover:text-brand-text'}`}>Home</Link>
            <Link to="/news" className={`text-sm font-bold transition-all ${location.pathname === '/news' ? 'text-brand-text underline underline-offset-4 decoration-2 decoration-brand-text' : 'text-brand-secondary hover:text-brand-text'}`}>AI News</Link>
            <Link to="/tools" className={`text-sm font-bold transition-all ${location.pathname === '/tools' ? 'text-brand-text underline underline-offset-4 decoration-2 decoration-brand-text' : 'text-brand-secondary hover:text-brand-text'}`}>AI Tools</Link>
            <Link to="/threads" className={`text-sm font-bold transition-all ${location.pathname === '/threads' ? 'text-brand-text underline underline-offset-4 decoration-2 decoration-brand-text' : 'text-brand-secondary hover:text-brand-text'}`}>Viral Threads</Link>
          </div>

          {/* Right Actions */}
          <div className="flex items-center gap-3 ml-auto">
            <Link to="/admin" className="hidden md:block text-brand-muted hover:text-brand-mint transition-colors p-2" aria-label="Admin Settings">
              <SafeIcon icon="Settings" className="w-4 h-4" />
            </Link>
          </div>

        </div>
      </div>
    </nav>
  );
};

export default Navbar;